/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * RedoIcon
 */
export default class RedoIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M21.967 2.957c-.6 0-1 .4-1 1v3.7l-2.9-2.8c-.8-.8-2.1-1.8-3.7-2.3-5.4-1.8-11.1.9-12.8 6.1-.9 2.5-.7 5.3.4 7.7 1.2 2.4 3.2 4.2 5.7 5.1 1.1.3 2.2.5 3.3.5 4.1 0 7.9-2.5 9.4-6.7.2-.5-.1-1.1-.6-1.3-.5-.2-1.1.1-1.3.6-1.5 4.2-6 6.3-10.2 4.9-2-.7-3.6-2.1-4.5-4.1-.9-1.9-1-4.1-.3-6.2 1.4-4.1 6-6.3 10.3-4.9 1 .3 1.9.9 3 1.9l2.7 2.8h-3.5c-.6 0-1 .4-1 1s.4 1 1 1h6c.1 0 .2 0 .3-.1h.2c.1 0 .2-.1.3-.2 0 0 0-.1.1-.1 0-.1.1-.1.1-.2v-.2V3.957c0-.6-.4-1-1-1z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

